import { useEffect, useState, useRef } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useLocation, useHistory } from "react-router";

import { ProductHorizontal } from "../../components/Card";
import { Grid, Col, Section, Container } from "../../components/Layout";
import { Heading } from "../../components/UI/Typoraphy";
import { Button } from "../../components/UI";
import { Flex } from "../../components/shared";

import Filter from "./Filter";
import FilterIcon from "./FIlterIcon";
import Map from "../../components/Map";

import BackIcon from "../../assets/back.svg";

import { mq } from "../../components/responsive";

import {
  NEWEST,
  TOP_REVIEW,
  LOW_TO_HIGH,
  HIGH_TO_LOW,
  NEAR_BY,
  MAP,
  FILTER,
  PRODUCT,
  sort,
} from "./contants";

import * as api from "../../utils/api";

const products = [
  {
    _id: "1",
    title: "Trang An",
    price: 120.0,
    location: "Ninh Binh",
    image: "/images/TrangAn.png",
    wished: false,
    rating: 3,
    public_date: "11/2/2020",
    tags: ["Food and Beverage", "Artisan Villages"],
  },
  {
    _id: "2",
    title: "Ghenh Da Dia",
    price: 20.0,
    location: "Phu Yen",
    image: "/images/GhenhDaDia.jpg",
    wished: true,
    rating: 5,
    public_date: "11/1/2020",
    tags: ["Artisan Villages"],
  },
  {
    _id: "3",
    title: "Hoi an Accent Town",
    price: 35.0,
    location: "Quang Nam",
    image: "/images/hoian.jpg",
    wished: false,
    rating: 4.6,
    public_date: "11/6/2020",
    tags: ["Seasonal Festival"],
  },

  {
    _id: "4",
    title: "Trang An",
    price: 65.0,
    location: "Ninh Binh",
    image: "/images/trangan.jpg",
    wished: false,
    rating: 1.2,
    public_date: "11/12/2019",
    tags: ["Food and Beverage"],
  },

  {
    _id: "5",
    title: "Mekong Delta",
    price: 265.0,
    location: "Mekong",
    image: "/images/mekongdelta.jpg",
    wished: false,
    rating: 3,
    public_date: "11/11/2020",
    tags: ["Outdoor Acitivites"],
  },
];

const Experiences = () => {
  const [sticky, setSticky] = useState(false);
  const [view, setView] = useState(PRODUCT);

  const [destination, setDestination] = useState({
    name: "Phu Yen",
    image_cover: "/images/GhenhDaDia.jpg",
    experiences: products,
  });

  useEffect(() => {
    if (view === FILTER) {
      disableBodyScroll(window);

      return () => {
        enableBodyScroll(window);
      };
    }
  }, [view]);

  const { search, state = {} } = useLocation();

  const initialFilters = {
    tags: {
      title: "Filter Tags",
      single: false,
      options: [
        { label: "All", value: "All" },
        { label: "Top Experiences", value: "Top Experiences" },
        { label: "Food and Beverage", value: "Food and Beverage" },
        { label: "Outdoor Acitivites", value: "Outdoor Acitivites" },
        { label: "Artisan Villages", value: "Artisan Villages" },
        { label: "Seasonal Festival", value: "Seasonal Festival" },
      ],
      name: "tags",
      value: (state && state.filters && state.filters.tags.value) || ["All"],
    },
    price: {
      title: "Price",
      single: true,
      options: [
        { label: "Low to high", value: LOW_TO_HIGH },
        { label: "High to low", value: HIGH_TO_LOW },
      ],
      name: "price",
      value: (state && state.filters && state.filters.price.value) || [],
    },
    others: {
      title: "Others",
      single: true,
      options: [
        { label: "Newest", value: NEWEST },
        { label: "Top review", value: TOP_REVIEW },
        { label: "Nearby", value: NEAR_BY },
      ],
      name: "others",
      value: (state && state.filters && state.filters.others.value) || [],
    },
  };

  const [filters, setFilters] = useState(initialFilters);

  const stickyEle = useRef();

  const history = useHistory();

  useEffect(() => {
    const query = new URLSearchParams(search);

    if (query.has("d")) {
      const fetchExperiences = async (destination) => {
        const { data } = await api.fetchExperiences(destination);
        if (data.status === "success") {
          setDestination((destination) => ({
            ...destination,
            ...data.data.destination,
          }));
        }
      };

      fetchExperiences(query.get("d"));
    }

    const handleObserver = (entities) => {
      const target = entities[0];
      setSticky(target.intersectionRatio >= 1);
    };

    const observer = new IntersectionObserver(handleObserver, {
      threshold: [1],
    });
    const ele = stickyEle.current;
    if (ele) {
      observer.observe(ele);
      return () => {
        observer.unobserve(ele);
      };
    }
  }, [stickyEle.current]);

  const handleApply = (d) => {
    if (d.name && d.name !== destination.name) {
      history.push({
        pathname: `/experiences`,
        search: `?d=${d.name}`,
        state: { filters },
      });
    }
    setView(PRODUCT);
  };

  const handleClear = () => {
    setFilters(initialFilters);
  };

  const handleFilterChange = (filter, value) => {
    let filterValue;
    filterValue = value;

    setFilters((filters) => {
      const current = filters[filter];
      return {
        ...filters,
        [filter]: {
          ...current,
          value: filterValue,
        },
      };
    });
  };

  const handleShowMap = () => setView(MAP);

  return (
    <Grid
      gutter={{ xs: 0, md: 24 }}
      style={{
        backgroundColor: "#fafafb",
        height: "calc(100vh - 8rem)",
        overflowY: "auto",

        "&::-webkit-scrollbar": {
          display: "none",
        },

        [mq.md]: { height: "calc(100vh - 10rem)" },

        [mq.lg]: {
          backgroundColor: "unset",
          height: "fit-content",
          overflowY: "unset",
        },
      }}
    >
      <Col
        span={{ xs: 4, lg: 6 }}
        style={{
          "&": {
            [mq.lg]: {
              order: 3,
              height: "calc(100vh)",
              paddingTop: "10rem !important",
            },
          },
        }}
      >
        <Flex
          css={{
            flexDirection: "column",
            height: view === MAP ? "100%" : 0,
            transition: "all 0.25s ease-in-out",

            [mq.lg]: {
              height: "100%",
            },
          }}
        >
          <Container
            style={{
              paddingTop: "2.5rem",
              paddingBottom: "2.5rem",
              display: "flex",
              justifyContent: "space-between",

              [mq.lg]: {
                display: "none",
              },
            }}
          >
            <img
              src={BackIcon}
              alt="back-button"
              onClick={() => setView(PRODUCT)}
            />
            <div onClick={() => setView(FILTER)}>
              <FilterIcon open={view === FILTER} />
            </div>
          </Container>
          <div css={{ flex: 1 }}>
            <Map />
          </div>
        </Flex>
      </Col>
      <Col
        span={{ xs: 4, md: 12 }}
        style={{
          display: view === MAP ? "none" : "block",
          padding: "0 !important",
          position: "sticky",
          top: 0,

          [mq.lg]: { display: "block", order: 1 },
        }}
      >
        <Flex
          css={{
            height: "37rem",
            backgroundImage: `url("${destination.image_cover}")`,
            alignItem: "center",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            justifyContent: "center",
            flexDirection: "column",

            "&:before": {
              position: "absolute",
              content: `""`,
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              background: "rgba(3, 3, 3, 0.3)",
            },

            [mq.lg]: {
              height: "60rem",
              position: "relative",
            },
          }}
        >
          <Section>
            <Heading
              level={3}
              style={{
                color: "#ffffff",
                textAlign: "center",
                [mq.lg]: {
                  fontSize: "4rem",
                },
              }}
            >
              {destination.name}
            </Heading>
          </Section>
        </Flex>
      </Col>
      <Col
        span={{ xs: 4, lg: 6 }}
        style={{
          display: view === MAP ? "none" : "block",

          "&": {
            [mq.lg]: {
              display: "block",
              order: 2,
              height: "calc(100vh - 10rem)",
              paddingTop: "14rem !important",
              paddingBottom: "10rem !important",
            },
          },
        }}
      >
        <Flex
          css={{
            justifyContent: "center",
            zIndex: 5,
          }}
        >
          <Button
            type="link"
            style={{
              backgroundColor: "#ffffff",
              marginTop: "3rem",
              marginBottom: "2rem",

              [mq.lg]: {
                display: "none",
              },
            }}
            onClick={handleShowMap}
          >
            Show map
          </Button>
        </Flex>
        <Section
          style={{
            paddingTop: "4rem",
            backgroundColor: "#ffffff",
            boxShadow: "0px 6px 14px rgba(0, 0, 0, 0.06)",
            borderRadius: "32px 32px 0 0",
            position: "sticky",
            top: "6rem",
            height: "calc(100vh - 8rem - 6rem)",

            "&:before": {
              content: `""`,
              position: "absolute",
              width: "12rem",
              height: "4px",
              top: "2rem",
              transform: "translateX(-50%)",
              left: "50%",
              backgroundColor: "#BDBDBD",
              borderRadius: "2px",

              [mq.md]: {
                height: "calc(100vh - 10rem - 6rem)",
              },

              [mq.lg]: {
                display: "none",
              },
            },

            [mq.lg]: {
              position: "relative",
              padding: "8rem 0 0 15rem",
              borderRadius: "none",
              boxShadow: "none",
              height: "100%",
              top: "unset",
            },
          }}
          ref={stickyEle}
        >
          <div
            css={{
              position: "absolute",
              right: "4rem",
              top: "2rem",
              zIndex: 2,
              display: sticky ? "block" : "none",

              [mq.lg]: {
                display: "block",
                top: "4rem",
                right: "unset",
                cursor: "pointer",
              },
            }}
            onClick={() =>
              setView((view) => (view === FILTER ? PRODUCT : FILTER))
            }
          >
            <FilterIcon open={view === FILTER} />
          </div>

          <Filter
            expand={view === FILTER}
            filters={filters}
            handleApply={handleApply}
            handleClear={handleClear}
            handleFilterChange={handleFilterChange}
          />

          <Grid
            gutter={{ xs: 16, lg: 40 }}
            style={{
              overflowY: sticky ? "auto" : "hidden",
              height: "100%",
              transform: view === PRODUCT ? "none" : "translateX(-120%)",
              position: view === PRODUCT ? "relative" : "absolute",
              transition: "transform 0.25s ease-in",
              display: "block",
              top: view === PRODUCT ? "unset" : 0,

              [mq.xl]: {
                minHeight: "80rem",
              },
            }}
          >
            <Col
              style={{
                textAlign: "center",
                transition: "opacity 0.25s ease-in",
                opacity: sticky ? 1 : 0,
                height: sticky ? "fit-content" : 0,
                overflow: "hidden",

                [mq.lg]: {
                  display: "none",
                },
              }}
            >
              <Button
                type="link"
                style={{
                  backgroundColor: "#ffffff",
                }}
                onClick={handleShowMap}
              >
                Show map
              </Button>
            </Col>

            {destination.experiences
              .filter(
                (e) =>
                  filters.tags.value.includes("All") ||
                  (e.tags &&
                    !e.tags.every((tag) => !filters.tags.value.includes(tag)))
              )
              .sort(
                (a, b) =>
                  sort(filters.price.value[0], [a, b]) ||
                  sort(filters.others.value[0], [a, b])
              )
              .map((e, i) => (
                <Col key={i} span={{ xs: 4, md: 12, xl: 12 }}>
                  <ProductHorizontal data={e} />
                </Col>
              ))}
          </Grid>
        </Section>
      </Col>
    </Grid>
  );
};

export default Experiences;
